(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rh-newsletter-product-counter"] && !Shopify.designMode) return;
  try {
    (() => {
    const parseISO = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second, millisecond, zone] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second), Number(millisecond || 0)));
      if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day) || date.getUTCHours() !== Number(hour) || date.getUTCMinutes() !== Number(minute) || date.getUTCSeconds() !== Number(second) || date.getUTCMilliseconds() !== Number(millisecond || 0)) return NaN;
      if (zone !== 'Z') {
        if (Number(zone.slice(1, 3)) > 14 || Number(zone.slice(4, 6)) > 59) return NaN;
        if (Number(zone.slice(1, 3)) === 14 && Number(zone.slice(4, 6)) !== 0) return NaN;
      }
      return Date.parse(value);
    };
    const mount = (root) => {
      if (root.dataset.w2CounterMounted) return;
      root.dataset.w2CounterMounted = 'true';
      const timerEnd = parseISO(root.dataset.timerEnd);
      const hideAt = parseISO(root.dataset.hideAt);
      const accessUntil = root.dataset.accessUntil ? parseISO(root.dataset.accessUntil) : hideAt;
      if (!Number.isFinite(timerEnd) || !Number.isFinite(hideAt) || !Number.isFinite(accessUntil) || accessUntil > hideAt || hideAt < timerEnd) {
        root.remove();
        return;
      }
      const countdown = root.querySelector('[data-w2-counter-countdown]');
      const units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => root.querySelector(`[data-w2-counter-${unit}]`));
      let interval;
      const stop = () => {
        window.clearInterval(interval);
        window.removeEventListener('pageshow', tick);
        document.removeEventListener('visibilitychange', tick);
      };
      const tick = () => {
        if (!root.isConnected) {
          stop();
          return;
        }
        const now = Date.now();
        if (now >= hideAt || now >= accessUntil) {
          root.remove();
          stop();
          return;
        }
        if (root.hidden) {
          root.hidden = false;
        }
        if (!countdown) return;
        if (now >= timerEnd) {
          countdown.hidden = true;
          return;
        }
        const seconds = Math.ceil((timerEnd - now) / 1000);
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        units.forEach((element, index) => {
          if (element) element.textContent = index === 0 ? String(values[index]) : String(values[index]).padStart(2, '0');
        });
        countdown.hidden = false;
      };
      tick();
      if (!root.isConnected) return;
      interval = window.setInterval(tick, 1000);
      window.addEventListener('pageshow', tick);
      document.addEventListener('visibilitychange', tick);
    };
    const mountAll = (scope) => {
      if (scope.matches?.('[data-rh-w2-product-counter]')) mount(scope);
      scope.querySelectorAll('[data-rh-w2-product-counter]').forEach(mount);
    };
    mountAll(document);
    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
